// SummaryTab.js
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  FilterControls,
  SummaryCard,
  OrderTable,
  WarehouseSummary,
  WarehouseTables,
  getMaterialTypes,
  getFilteredOrders,
  calculateTotals,
  separateByPlace,
} from '../../Component/SharedComponents';

const SummaryTab = ({
  buyOrders,
  saleOrders,
  date,
  setDate,
  onViewDetail,
  allData,
}) => {
  const [materialFilter, setMaterialFilter] = useState('all');
  const allOrders = [...(buyOrders || []), ...(saleOrders || [])];
  const materialTypes = getMaterialTypes(allOrders);
  const filteredOrders = getFilteredOrders(allOrders, materialFilter);
  const totals = calculateTotals(filteredOrders);

  const { oldWarehouse, newWarehouse, otherWarehouse } =
    separateByPlace(filteredOrders);

  return (
    <>
      <FilterControls
        materialTypes={materialTypes}
        currentFilter={materialFilter}
        setFilter={setMaterialFilter}
        date={date}
        setDate={setDate}
      />

      <WarehouseSummary
        oldWarehouseOrders={oldWarehouse}
        newWarehouseOrders={newWarehouse}
        otherWarehouseOrders={otherWarehouse}
        type="SUMMARY"
      />

      <WarehouseTables
        oldWarehouseOrders={oldWarehouse}
        newWarehouseOrders={newWarehouse}
        otherWarehouseOrders={otherWarehouse}
        allData={allData}
        onViewDetail={onViewDetail}
      />
    </>
  );
};

SummaryTab.propTypes = {
  buyOrders: PropTypes.array,
  saleOrders: PropTypes.array,
  date: PropTypes.string.isRequired,
  setDate: PropTypes.func.isRequired,
  onViewDetail: PropTypes.func.isRequired,
};

SummaryTab.defaultProps = {
  buyOrders: [],
  saleOrders: [],
};

export default SummaryTab;
